export default "__VITE_ASSET__zqNW_IIpKYGi5s0FprE05g__"